<div class="projects mb-4">
    <div class="card">
            <div class="card-header header-background">
                  <div class="row">
                      <div class="col-sm-3">
                          <h2>Capacitación</h2>
                      </div>
                  </div>
            </div>
    

            <div>
                <ul class="nav nav-tabs">
                    <li class="nav-item">
                        <a class="nav-link active" data-bs-toggle="tab" href="#introduccion">Inducción</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" data-bs-toggle="tab" href="#distancia" (click)="showCapacitacionDistancia = true">A Distancia</a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" data-bs-toggle="tab" href="#tutorias" (click)="showCapacitacionTutorias = true">Tutorías</a>
                  </li>
                </ul>
                <div id="myTabContent" class="tab-content">

                    <div class="tab-pane fade show active" id="introduccion">
                        <div style="padding: 20px 50px;">
                            <div class="row">
                                <app-capacitacion-inicio ></app-capacitacion-inicio>  
                            </div>
                        </div>
                    </div>

                    <div class="tab-pane fade show" id="distancia">
                        <div style="padding: 20px 50px;">
                            <div class="row">
                                <app-capacitacion-distancia *ngIf="showCapacitacionDistancia"></app-capacitacion-distancia>  
                            </div>
                        </div>
                    </div>

                    <div class="tab-pane fade show" id="tutorias">
                        <div style="padding: 20px 50px;">
                            <div class="row">
                                <app-capacitacion-tutorias *ngIf="showCapacitacionTutorias"></ app-capacitacion-tutorias>  
                               
                            </div>
                        </div>
                    </div>

                </div>

            </div>
    </div>
  </div>



    <!-- <mat-drawer-content style="margin-left: 1px;">
        <app-capacitacion-inicio *ngIf="menuMostrar==='inicio'"></app-capacitacion-inicio>  
        <app-capacitacion-presencial *ngIf="menuMostrar==='presencial'"></app-capacitacion-presencial>
        <app-capacitacion-distancia *ngIf="menuMostrar==='distancia'"></app-capacitacion-distancia>  
        
    </mat-drawer-content> -->